import axios from "axios"
import { customToast } from "../components/toast/custom-react-toastify/v1"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function CommerceApiApi(props) {
    return {
        searchCommerceApiStoreInfos: async ({ params, headers }) => {
            return await axios.get(`${MAIN_API_HOST}/commerce-api/commerce-api-store-infos`, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        addCommerceApiStoreInfos: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/commerce-api/commerce-api-store-infos`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        editCommerceApiStoreInfos: async ({ params, headers, body }) => {
            return await axios.put(`${MAIN_API_HOST}/commerce-api/commerce-api-store-infos`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        collectOrders: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/commerce-api/collect-orders`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        cancelOrder: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/commerce-api/cancel-order`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        returnConfirmOrder: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/commerce-api/return-confirm-order/from-return-exchanges`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        return {
                            res: null,
                            message: '서버와의 연결이 원할하지 않습니다.'
                        }
                    }

                    let res = err.response;

                    return {
                        res: res,
                        message: res.data?.message
                    }
                })
        },
        exchangeConfirmOrder: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/commerce-api/exchange-confirm-order/from-return-exchanges`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        return {
                            res: null,
                            message: '서버와의 연결이 원할하지 않습니다.'
                        }
                    }

                    let res = err.response;

                    return {
                        res: res,
                        message: res.data?.message
                    }
                })
        }
    }
}